var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0967,
    cy: 15.0967,
    r: 15.0967,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4304 23.0967C15.6375 23.0967 16.6475 22.2366 16.8794 21.0967H11.9805C12.2134 22.2366 13.2234 23.0967 14.4304 23.0967Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1062 15.0996C19.103 15.0996 19.1011 15.0996 19.0982 15.0996C16.5252 15.0996 14.4312 13.0066 14.4312 10.4326C14.4312 9.72559 14.5943 9.05664 14.8772 8.45459C14.7302 8.44067 14.5821 8.43164 14.4312 8.43164C11.8543 8.43164 9.76418 10.5205 9.76418 13.0986V14.9575C9.76418 16.2766 9.18606 17.5217 8.17214 18.3796C7.83425 18.6687 7.6841 19.1287 7.8052 19.5767C7.94826 20.0996 8.46316 20.4326 9.00515 20.4326H19.8552C20.4231 20.4326 20.9592 20.0647 21.0742 19.5085C21.1631 19.0786 21.0103 18.6477 20.676 18.3677C19.7061 17.5537 19.1463 16.3596 19.1062 15.0996Z",
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4297 10.4307C22.4297 12.2715 20.9375 13.7637 19.0967 13.7637C17.2559 13.7637 15.7637 12.2715 15.7637 10.4307C15.7637 8.58984 17.2559 7.09766 19.0967 7.09766C20.9375 7.09766 22.4297 8.58984 22.4297 10.4307Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.a1c793d5edf01ee295d70373a3d881f1.svg";
export { ForwardRef as ReactComponent };